// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingPlaceholder-container-39Mq-z","readyContainer":"LoadingPlaceholder-readyContainer-3lYTKK","readyText":"LoadingPlaceholder-readyText-3BS2U4"};